
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import CrmHistoryFile from "@/models/crm/crm-history-file";
import AppAwsFilesEdit from "@/components/aws-files-modules/AwsFilesEdit.vue";

export default Vue.extend({
	data() {
		return {
			message: ""
		};
	},
	props: {
		value: {
			required: true,
			type: Object as () => CrmHistory
		},
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				let p = (this.value.Props as any) || {};
				this.message = p.Message ?? "";
				this.value.Props = new CrmHistoryFile({Message: this.message});
			}
		}
	},
	methods: {
		onMessage(value: string) {
			this.message = value;
			(this.value.Props as any).Message = value;
			this.$emit("input", this.value);
		},
	},
	components: {
		AppAwsFilesEdit
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
